import { createFileRoute } from '@tanstack/react-router';

import { DestinationsContainer } from '@/features/destinations/containers';

export const Route = createFileRoute('/_layout/destinations/')({
  component: DestinationsContainer,
});
